import type { SourceWalk } from '../pages/composer/useSourceWalk'
import { btn } from './ui'

/**
 * The guided "Fix" walk's bar (pages/composer/useSourceWalk.ts), pinned at the
 * bottom: how many thoughts still need a source, Skip and Done. When none are
 * left it offers the way back to publishing.
 */
export function SourceWalkBar({ walk, onPublish }: { walk: SourceWalk; onPublish: () => void }) {
  if (!walk.active) return null
  return (
    <div
      role="region"
      aria-label="Adding sources"
      className="fixed inset-x-0 bottom-0 z-40 flex justify-center px-4 pb-[calc(16px+env(safe-area-inset-bottom))] pointer-events-none"
    >
      <div className="pointer-events-auto flex max-w-full items-center gap-2 rounded-full border border-border/60 bg-card py-1.5 pl-4 pr-1.5 font-sans text-[13px] font-medium text-foreground shadow-[var(--shadow-chip)]">
        <span aria-live="polite" className="min-w-0 truncate">
          {walk.done
            ? walk.skipped === 0
              ? 'Every thought has a source'
              : `Done · ${walk.skipped} skipped`
            : `Adding sources · ${walk.left} left`}
        </span>
        {walk.done ? (
          <>
            <button type="button" onClick={onPublish} className={btn.primary}>
              Back to publish
            </button>
            <button type="button" onClick={walk.stop} aria-label="Close" className={btn.ghost}>
              ×
            </button>
          </>
        ) : (
          <>
            <button type="button" onClick={walk.skip} className={btn.ghost}>
              Skip
            </button>
            <button type="button" onClick={walk.stop} className={btn.outline}>
              Done
            </button>
          </>
        )}
      </div>
    </div>
  )
}
